import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import RadioButton from "../radio/radioButtonCmp";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormControlLable from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { log } from "console";
import { useQueryClient } from "react-query";
import { LOAN_ID } from "../../config/cacheKey";

const style = {
  width: "100%",
  // maxWidth: 640,
  bgcolor: "background.paper",
};

export default function DividerDesignCmp(props: any) {
  const [id, setId] = React.useState();
  const queryClient = useQueryClient();
  const [submitFlag, setSubmitFlag] = React.useState<boolean>(true);
  queryClient.setQueryData(LOAN_ID, id);
  const handleChange = (event: any) => {
    setId(event.target.value);
    queryClient.setQueryData(LOAN_ID, event.target.value);
    props.setLoanId(event.target.value);
  };

  return (
    <>
      <div
        style={{
          background: `${props.bgcolor}`,
          marginBottom: "30px",
          direction: "rtl",
          borderRadius: "6px",
          padding: "2px 20px",
          border: "1.5px solid rgba(0,0,0,.12)",
          fontSize: "15px",
          color: "#212121",
          width: "100%",
        }}
      >
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="gender"
            onChange={handleChange}
            onKeyDown={(e) => {
              if (e.key === "Enter" && id !== null) {
                if (submitFlag) {
                  setSubmitFlag(false);
                  props.handleNext();
                }
              }
            }}
          >
            {props.value.map((item: any, index: number, array: any) => {
              let flag = true;

              if (array.length - 1 === index) {
                flag = false;
              }
              return (
                <List
                  sx={style}
                  component="nav"
                  aria-label="mailbox folders"
                  key={index}
                  style={{ background: `${props.bgcolor}` }}
                  className="col-lg-12 col-md-12"
                >
                  <ListItem>
                    <Grid
                      container
                      className="row"
                      spacing={2}
                      style={{ alignItems: "center" }}
                    >
                      <Grid
                        item
                        style={{ alignItems: "right", direction: "rtl" }}
                      >
                        <FormControlLable
                          value={item.id}
                          control={
                            <Radio
                              sx={{
                                color: "#DEDEDE",
                                "&.Mui-checked": {
                                  color: "#01AF43",
                                },
                              }}
                            />
                          }
                          label={""}
                        />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {!item.cardImage ? (
                          <img
                            className="designCard"
                            src={`images/defaultImg.jpg`}
                            alt="طرح انتخابی"
                          />
                        ) : (
                          <img
                            className="designCard"
                            src={`data:image/png;base64,${item.cardImage}`}
                            alt="طرح انتخابی"
                          />
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm
                        container
                        style={{
                          color: "#212121",
                          fontSize: "15px",
                          // marginTop: "-2vh",
                          marginBottom: "30px",
                          marginRight: "3vh",
                        }}
                      >
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Grid spacing={1}>
                          <Grid
                            xs={12}
                            style={{
                              textAlign: "right",
                              color: "#1D4A87",
                              fontSize: "18px",
                            }}
                          >
                            <b>{item.title}</b>
                            {item.isBySupplierCredit ? (
                              <b
                                style={{
                                  textAlign: "right",
                                  color: "#EE9D01",
                                  fontSize: "14px",
                                }}
                              >
                                &nbsp; &nbsp;(تضمین از محل اعتبار تامین کننده
                                &nbsp;&nbsp;|&nbsp;&nbsp;اعتبار باقیمانده:{" "}
                                {item.supplierCredit.toLocaleString()}
                                &nbsp;&nbsp;ریال)
                              </b>
                            ) : (
                              ""
                            )}
                            <br />
                            <br />
                          </Grid>
                          <Grid
                            style={{ textAlign: "right", lineHeight: "1.9" }}
                            xs={12}
                          >
                            <span
                              style={{
                                background: "#1D4A87",
                                borderRadius: "5px",
                                color: "white",
                              }}
                            >
                              &nbsp;&nbsp;تامین کننده مالی:{" "}
                              {item.financialSupplierTitle}&nbsp;&nbsp;
                            </span>
                            &nbsp;&nbsp; | &nbsp;&nbsp;
                            <span>سقف قابل اعطا: </span>
                            <span
                              style={{ marginLeft: "10px", fontWeight: "bold" }}
                            >
                              &nbsp;{item.maxAmount.toLocaleString("fa")} (ریال)
                            </span>
                            |
                            <span style={{ marginRight: "10px" }}>
                              سود تسهیلات:
                            </span>
                            <span style={{ fontWeight: "bold" }}>
                              &nbsp;&nbsp;{item.profitPercentage}% &nbsp;&nbsp;
                            </span>
                            |
                            <span style={{ marginRight: "10px" }}>
                              مهلت استفاده از تسهیلات:
                            </span>
                            <span style={{ fontWeight: "bold" }}>
                              &nbsp;&nbsp;{item.expirationDate_Persian}
                            </span>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </ListItem>

                  {flag && (
                    <Divider
                      style={{
                        border: `.6px solid ${props.borderColor}`,
                        marginTop: "6px",
                      }}
                    />
                  )}
                </List>
              );
            })}
          </RadioGroup>
        </FormControl>
      </div>
    </>
  );
}
